<template>
  <Card class="recommend-app" title="推荐服务">
    <div class="items" v-loading="loading">
      <div class="item" v-for="(item, index) in list" :key="index">
        <a v-if="item.url" class="pointer" @click="$openHome(item.url, item.name, Number(item.type || 1), 1)">
          <img :src="item.pic" />
          <div class="info">
            <div class="f16 text-overflow info-name">{{ item.name }}</div>
            <div class="gray6 text-overflow">{{ item.title }}</div>
          </div>
          <div class="entry">
            <div class="text-center entry-btn">点击进入</div>
          </div>
        </a>
        <template v-else>
          <img :src="item.pic" />
          <div class="info">
            <div class="f16 text-overflow info-name">{{ item.name }}</div>
            <div class="gray6 text-overflow">{{ item.title }}</div>
          </div>
        </template>
      </div>
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
      <div class="item flex-left" />
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";

export default {
  components: {
    Card,
  },

  computed: mapState({
    defaultShop: (state) => state.app.defaultShop,
  }),

  data() {
    return {
      list: [],
      loading: true,
    };
  },

  mounted() {
    const { shopIdStr } = this.defaultShop;
    this.$store.dispatch("trade/recommendApp", { shop_id: shopIdStr }).then((data) => {
      this.list = data;
      this.loading = false;
    });
  },
};
</script>
